import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn, Router } from '@angular/router';
import { AuthService } from 'app/core/auth/auth.service';
import { of, switchMap } from 'rxjs';

export const NoAuthGuard: CanActivateFn | CanActivateChildFn = (
    route,
    state
) => {
    const router: Router = inject(Router);

    // Check the authentication status
    return inject(AuthService)
        .check()
        .pipe(
            switchMap((authenticated) => {
                // If the user is authenticated...
                if (authenticated) {
                    let redirectURL = route.queryParamMap.get("redirectURL")
                    if (redirectURL?.length)
                        window.location.href = redirectURL
                    //router.navigate([redirectURL]);
                    return of(false);
                }

                // Allow the access
                return of(true);
            })
        );
};
